export const reviews: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Wine Studies Educator — London, United Kingdom',
    'My students finally understand the difference between viticulture decisions and winemaking choices. I used to waste hours searching for the right way to explain how grapes become wine. Now I enter the classroom fully prepared.',
  ],
  [
    'JW',
    'Jennifer W.',
    'Oenology Instructor — Dublin, Ireland',
    'I never arrive unprepared anymore. I know exactly how to explain sensory analysis or how to teach food-and-wine pairing principles. This resource does the heavy lifting for me.',
  ],
  [
    'NC',
    'Nora C.',
    'Hospitality and Wine Teacher — Amsterdam, Netherlands',
    'The lesson planning saves me countless hours. The integrated wine projects are organized step-by-step. I never improvise in front of my students anymore.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Wine Studies Educator | London, United Kingdom',
    "The material on viticulture and terroir completely changed how my students understand wine quality. They finally grasp how soil, climate, and vineyard management decisions influence the grapes and final wine. It's the clearest resource I've found. I use it from day one and it captures their attention immediately.",
  ],
  [
    'JW',
    'Jennifer W.',
    'Oenology Instructor | Dublin, Ireland',
    'The 150 activities alone are worth the price. I never improvise a lesson anymore. I finish every quarter knowing everything is prepared and ready.',
  ],
  [
    'TM',
    'Thomas M.',
    'Hospitality and Wine Teacher | Berlin, Germany',
    "The 50 wine projects transformed how my students see wine applications. Now they conduct tastings, analyze wine regions, design food pairings, and understand why wine knowledge matters professionally. I haven't found this quality in any other resource.",
  ],
  [
    'EH',
    'Elizabeth H.',
    'University Lecturer | Oxford, United Kingdom',
    'The wine terminology handbook gave me back my class time. I used to spend time explaining sensory vocabulary and production terminology. Now I show the handbook and students instantly understand wine concepts.',
  ],
  [
    'MS',
    'Martin S.',
    'Wine Studies Instructor | Copenhagen, Denmark',
    "The 100 case studies were eye-opening. My students finally understand why all this matters. They're analyzing real vineyard challenges, designing wine menus, conducting blind tastings, and exploring wine regions. This completely transformed how they see wine studies.",
  ],
];
